import { Navigate } from "react-router-dom";

import { useSelector } from "react-redux";

export default function ProtectedRoute({ children }) {
  const { status, isBootstrapping } = useSelector((state) => state.auth);

  /**
   * WAIT UNTIL BOOTSTRAP FINISHES
   */
  if (isBootstrapping) {
    return null;
  }

  /**
   * NOT AUTHENTICATED
   */
  if (status !== "authenticated") {
    return <Navigate to="/login" replace />;
  }

  /**
   * AUTHORIZED
   */
  return children;
}
